import { Reveal, Chapter } from "./Reveal";
import { scrollToId } from "../data/content";
import { ArrowUpRight } from "lucide-react";
import { useT } from "../i18n";

const About = () => {
  const t = useT();
  return (
    <section id="about" data-testid="about-section" className="bg-[#0B0E14] py-24 lg:py-32">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-14 px-4 sm:px-6 lg:grid-cols-2 lg:gap-20 lg:px-8">
        <div>
          <Reveal>
            <Chapter number="03" label={t.about.label} testid="about-chapter" />
          </Reveal>
          <Reveal delay={0.1}>
            <h2 data-testid="about-title" className="mt-8 font-display text-3xl font-semibold leading-tight text-white sm:text-4xl">
              {t.about.title}
            </h2>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-8 text-sm leading-relaxed text-slate-400 md:text-base">{t.about.p1}</p>
            <p className="mt-4 text-sm leading-relaxed text-slate-400 md:text-base">{t.about.p2}</p>
            <p className="mt-4 text-sm leading-relaxed text-slate-400 md:text-base">{t.about.p3}</p>
          </Reveal>
          <Reveal delay={0.26}>
            <button
              data-testid="about-cta"
              onClick={() => scrollToId("#partners")}
              className="group mt-10 inline-flex items-center gap-2 border border-gold/60 px-7 py-4 font-mono text-xs tracking-[0.2em] text-gold transition-[background-color,color,box-shadow] duration-300 hover:bg-gold hover:text-[#0B132B] hover:shadow-[0_0_28px_rgba(212,175,55,0.3)]"
            >
              {t.about.cta.toUpperCase()}
              <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>
          </Reveal>
        </div>

        <Reveal delay={0.2} className="relative">
          <div className="relative aspect-[4/3] lg:aspect-auto lg:h-full">
            <div className="absolute -right-4 -top-4 h-full w-full border border-gold/25" />
            <div className="clipped-frame relative h-full min-h-[320px] overflow-hidden">
              <img
                src="/assets/container-load.png"
                alt="Container loading for export shipment — CRESSCO DAYA UTAMA"
                className="h-full w-full object-cover transition-transform duration-700 hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B0E14]/70 via-transparent to-transparent" />
            </div>
            <p className="absolute bottom-4 left-4 font-mono text-[10px] tracking-[0.28em] text-slate-300">
              EXPORT LOGISTICS — INDONESIA
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default About;
